module.exports = require("@wildboar/x500/src/lib/modules/SelectedAttributeTypes/ia5String.oa");